<db-dialog-wrapper [dialog]="this" [width]="'488px'" [canClose]="!loading" [hasCloseButton]="!loading" [canCloseByBackdrop]="!loading">
  <div class="db-remove-redirect-dialog db-remove-redirect-dialog-sm">
    <div class="db-remove-redirect-dialog__header">{{'text_confirmRedirectRemove.header' | dbText}}</div>
    <div class="db-remove-redirect-dialog__message">
      <span [innerHTML]="'text_confirmRedirectRemove.message' | dbText"></span>
    </div>
    <div class="db-remove-redirect-dialog__buttons">
      <a class="db-button" (click)="cancel()" [ngClass]="{'db-button_disabled': loading}"><span>{{"text_cancel" | dbText}}</span></a>
      <a class="db-button db-button_danger" (click)="confirm()" *ngIf="!multipleRules">
        <span *ngIf="!loading">{{'text_delete' | dbText}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
      <a class="db-button db-button_danger" (click)="removeRedirects()" *ngIf="multipleRules">
        <span *ngIf="!loading">{{'text_delete' | dbText}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</db-dialog-wrapper>
